import AbstractCRMApi from '../../AbstractCRMApi';
import GetDictionaryResponse from '../Responses/DictionaryResponse';
import GetAllLanguagesResponse from '../Responses/LanguagesResponse';

class LanguagesApi extends AbstractCRMApi {
    public endpoint: string = 'languages';

    public async getAll(): Promise<GetAllLanguagesResponse> {
        return (await this.get('')).data;
    }

    public async getNames(): Promise<GetDictionaryResponse> {
        return (await this.get('/names')).data;
    }
}

export default new LanguagesApi();
